'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import MobilePanelHeader from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelHeader';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CALYPSO } from 'HubStyleTokens/colors';
const textPath = 'ecosystem-marketplace-solutions-ui.storefront.filters';
const StyledHeaderAction = styled(UIButton).withConfig({
  displayName: "FilterDrilldownPanelWrapper__StyledHeaderAction",
  componentId: "sc-1t3i7n0-0"
})(["&&&&{padding:4px;}"]);
const StyledPanelBody = styled(UIPanelBody).withConfig({
  displayName: "FilterDrilldownPanelWrapper__StyledPanelBody",
  componentId: "sc-1t3i7n0-1"
})(["&&{padding:25px;}"]);

const FilterDrilldownPanelWrapper = ({
  applyFilters,
  children,
  onPanelClose,
  title
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
      itemLeft: /*#__PURE__*/_jsxs(StyledHeaderAction, {
        autoFocus: true,
        use: "transparent",
        onClick: () => onPanelClose(false),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "left",
          color: CALYPSO,
          size: "xs"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.allFilters`
        })]
      }),
      itemRight: /*#__PURE__*/_jsx(StyledHeaderAction, {
        className: "p-right-3",
        use: "transparent",
        onClick: applyFilters,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.apply`
        })
      }),
      title: title
    }), /*#__PURE__*/_jsx(StyledPanelBody, {
      children: children
    })]
  });
};

FilterDrilldownPanelWrapper.propTypes = {
  applyFilters: PropTypes.func.isRequired,
  children: PropTypes.node,
  onPanelClose: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};
export default FilterDrilldownPanelWrapper;